module.exports = __webpack_public_path__ + "static/media/img_cal16.dccfea60.jpg";